import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('tenants:read')) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/organization/pages/tenant-profile-page')),
});
